import $ from 'jquery';

let listId = 0;

function collapsibleList($list, threshold, label) {
    var $listItems = $list.children(),
        $toggleTrigger = null,
        $listItemsOverThreshold = null,
        isOpen = false,
        $triggerParent,
        triggerId;

    function openList($toggleTrigger, $listItemsOverThreshold) {
        isOpen = !isOpen;

        setLinkText($toggleTrigger, isOpen);
        setListItemVisibility($listItemsOverThreshold, isOpen);
    }

    if ($listItems.length > threshold) {
        $listItemsOverThreshold = $($listItems.toArray().slice(threshold));
        $toggleTrigger = $('<a href="#"></a>').insertAfter($list.parent());
        $triggerParent = $toggleTrigger.parent();
        triggerId = `trigger-${listId++}`;

        if (label) {
            $toggleTrigger.attr('id', triggerId);
            $toggleTrigger.attr('aria-labelledby', `${triggerId} ${label}`);
        }

        setLinkText($toggleTrigger, isOpen);
        setListItemVisibility($listItemsOverThreshold, isOpen);

        if ($triggerParent.attr('data-opened') === 'true') {
            openList($toggleTrigger, $listItemsOverThreshold);
        }

        $toggleTrigger.on('click', function(e) {
            e.preventDefault();

            openList($toggleTrigger, $listItemsOverThreshold);

            if (isOpen) {
                $triggerParent.data('opened', 'true');
            } else {
                $triggerParent.removeAttr('data-opened');
            }
        });
    }
}

function setLinkText($element, isOpen) {
    $element.text(isOpen ? 'View less' : 'View all');
}

function setListItemVisibility($listItems, isOpen) {
    $listItems[isOpen ? 'removeClass' : 'addClass']('overThresholdFacet');
}

export default collapsibleList;
